import { defineMessages } from 'react-intl';

export default defineMessages({
  lockedFeature: {
    id: 'view.settings.lockedFeature',
    defaultMessage: 'Feature only available for essential offer',
  },
});
